export default function LimitsViewItem({
  label,
  value,
  maxValue,
}: {
  label: string;
  value: number | string;
  maxValue?: number;
}) {
  return (
    <div className="flex text-button-xs text-black-500 px-2">
      <span className="text-button-xs">{label}</span>
      <span className="mr-0.5 ml-auto text-black-950">{value}</span>
      {maxValue && <span>/ {maxValue}</span>}
    </div>
  );
}
